/**
 * Owner: Masa Bayu
 * File: batch03-fixtures.ts
 * Date:Time: 2026-09-19 23:41
 * Description: Batch 3 certification fixtures — chinese · japanese · korean (CJK).
 */
import {} from './batch03-codes';
function fixturesFor(familyId, scriptLabel, notes) {
    return Object.freeze([
        Object.freeze({
            id: `fixture:${familyId}/identity`,
            familyId,
            area: 'identity',
            description: `canonical languageId samples for ${familyId}`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/script-character`,
            familyId,
            area: 'script',
            description: `${scriptLabel} script / character identity`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/direction-ltr`,
            familyId,
            area: 'direction',
            description: 'LTR default + explicit ltr override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/content-multilingual`,
            familyId,
            area: 'content',
            description: 'primary + contentLanguages + inline override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxw-author-preserve`,
            familyId,
            area: 'qxw',
            description: 'QXW root metadata author → preserve',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxp-publish-preserve`,
            familyId,
            area: 'qxp',
            description: 'QXP artifact preserve-through-publish',
        }),
        Object.freeze({
            id: `fixture:${familyId}/reader-typography`,
            familyId,
            area: 'reader',
            description: 'CJK typography stacks (render contract)',
        }),
        Object.freeze({
            id: `fixture:${familyId}/search-segment`,
            familyId,
            area: 'search',
            description: notes.search,
        }),
        Object.freeze({
            id: `fixture:${familyId}/navigation-writing-mode`,
            familyId,
            area: 'navigation',
            description: notes.nav,
        }),
        Object.freeze({
            id: `fixture:${familyId}/annotation-anchors`,
            familyId,
            area: 'annotation',
            description: 'original text preserved for anchors',
        }),
        Object.freeze({
            id: `fixture:${familyId}/a11y-lang-semantics`,
            familyId,
            area: 'accessibility',
            description: notes.a11y,
        }),
        Object.freeze({
            id: `fixture:${familyId}/serialize-roundtrip`,
            familyId,
            area: 'serialization',
            description: 'metadata / content round-trip',
        }),
        Object.freeze({
            id: `fixture:${familyId}/regression-suite`,
            familyId,
            area: 'regression',
            description: 'content id stable under override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/provenance-chain`,
            familyId,
            area: 'provenance',
            description: 'source → evidence area trace',
        }),
    ]);
}
export const QX_BATCH_03_CHINESE_FIXTURES = fixturesFor('chinese', 'Hans/Hant', {
    search: 'NFC + cjk_script analyzer · script_aware segment (no whitespace default)',
    nav: 'horizontal-tb default · vertical-rl capable (Hans/Hant)',
    a11y: 'content lang zh-Hans/zh-Hant + reading order for AT',
});
export const QX_BATCH_03_JAPANESE_FIXTURES = fixturesFor('japanese', 'Jpan', {
    search: 'NFC + cjk_script analyzer · script_aware segment (mixed scripts)',
    nav: 'horizontal-tb default · vertical-rl allowed for Japanese',
    a11y: 'content lang ja + LTR reading order for AT',
});
export const QX_BATCH_03_KOREAN_FIXTURES = fixturesFor('korean', 'Kore', {
    search: 'NFC + cjk_script analyzer · script_aware Hangul segment prep',
    nav: 'horizontal-tb default · vertical-rl capable (Kore)',
    a11y: 'content lang ko + LTR reading order for AT',
});
export const QX_BATCH_03_FIXTURES = Object.freeze([
    ...QX_BATCH_03_CHINESE_FIXTURES,
    ...QX_BATCH_03_JAPANESE_FIXTURES,
    ...QX_BATCH_03_KOREAN_FIXTURES,
]);
export const QX_BATCH_03_CHINESE_SAMPLE_LANGUAGES = Object.freeze([
    'zh-Hans',
    'zh-Hant',
]);
export const QX_BATCH_03_JAPANESE_SAMPLE_LANGUAGES = Object.freeze([
    'ja',
]);
export const QX_BATCH_03_KOREAN_SAMPLE_LANGUAGES = Object.freeze([
    'ko',
]);
export const QX_BATCH_03_TEXT_SAMPLES = Object.freeze({
    'zh-Hans': '你好，世界 — 简体中文认证样本。',
    'zh-Hant': '你好，世界 — 繁體中文認證樣本。',
    ja: 'こんにちは世界 — 日本語認証サンプル。',
    ko: '안녕하세요 세계 — 한국어 인증 샘플.',
    composed: 'cafe\u0301',
});
export function listBatch03FixtureIds(familyId) {
    const list = familyId === 'chinese'
        ? QX_BATCH_03_CHINESE_FIXTURES
        : familyId === 'japanese'
            ? QX_BATCH_03_JAPANESE_FIXTURES
            : familyId === 'korean'
                ? QX_BATCH_03_KOREAN_FIXTURES
                : QX_BATCH_03_FIXTURES;
    return Object.freeze(list.map((f) => f.id));
}
export function fixturesForBatch03Family(familyId) {
    if (familyId === 'chinese') {
        return QX_BATCH_03_CHINESE_FIXTURES;
    }
    if (familyId === 'japanese') {
        return QX_BATCH_03_JAPANESE_FIXTURES;
    }
    return QX_BATCH_03_KOREAN_FIXTURES;
}
//# sourceMappingURL=batch03-fixtures.js.map